<template>
 <div id="app">  
  <div class="container">
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionGeneral variant="info">General Information</b-btn>
          </b-card-header>
          <b-collapse id="accordionGeneral" visible role="tabpanel">
            <b-card-body>
              
  
              
              <div id="demo">
                <!-- SYNCHRONIZED WITH Batch.vue line 27 -->
                <b-table striped hover bordered fixed :items="genItems" class="table table-sm">
                  <template v-slot:cell(value)="row">
                   
                    <div v-if="(row.item.name == 'SE2_ANALYSIS')">{{batchItems[0].SE2_Comments}}</div>
                    <div v-if="!( row.item.name == 'SE2_ANALYSIS')">{{row.item.value}}
                      <img v-if="row.item.name == 'NUM_CPUS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'NUM_CPU_CORES'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_CORE_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'TOTAL_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files and temp files.  Source: DBA_DATA_FILES and DBA_TEMP_FILES"></img>
                      <img v-if="row.item.name == 'TOTAL_DATAFILE_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files.  Source: DBA_DATA_FILES"></img>
                      <img v-if="row.item.name == 'USED_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all segments.  Source: DBA_SEGMENTS"></img>
                      <img v-if="row.item.name == 'HOSTS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: DBA_HIST_ DATABASE_INSTANCE or STATS$ DATABASE_INSTANCE"></img>
                      <img v-if="row.item.name == 'HOSTS_CURRENT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: GV$INSTANCE"></img>
                      <img v-if="row.item.name == 'HOST_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The host of the database instance used to collect data."></img>
                      <img v-if="row.item.name == 'INSTANCE#_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The database instance number used to collect data.  DBCSI pulls data from all instances in a RAC Cluster, but it can sometimes be helpful to know which instance was used to collect data."></img>
                      <!--<img v-if="(row.item.name == 'AWR_MINER_VER' && row.item.value.includes('aws'))" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Reminder: best practice is to always download the latest version of the DBCSI data collection script from the DBCSI Add page."></img>-->
                      <img v-if="(row.item.name == 'AWR_MINER_VER' && !row.item.value.includes('aws'))" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic AWR Miner script output.  DBCSI works best if you use the DBCSI-specific data collection script from the DBCSI Add page."></img>
                      <img v-if="row.item.name == 'STATSPACK_MINER_VER'" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: when using STATSPACK data, some features of DBCSI will be limited."></img>
                    </div>

                  </template>
                </b-table>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>


        <!-- Comparative Info       -->
        <b-card
          v-if="loaded"
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionComparative variant="info">Comparative Information</b-btn>
          </b-card-header>
          <b-collapse id="accordionComparative" v-model="showCollapseSummary" visible role="tabpanel">
            <b-card-body>

                <div
                  class="Chart"
                >
                  <h2>Databases: Comparative Distributions</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">These charts show the percentile distribution of various metrics (such as Database Size) for databases analyzed by DBCSI.  These charts show you how your database's metrics compare relative to other databases.  The horizontal axis is the metric displayed using a logarithmic scale.  The vertical axis represents the percentile for databases ordered by the metric.  0 on the vertical axis is the smallest database for that metric.  50 on the vertical axis represents the database with the median value.  100 on the vertical axis represents the largest database for that metric.  Each database is plotted as a dot showing its metric value and its percentile.</p>
                    </div>
                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="Database Size (GB)"
                    chart_id="TOTAL_DB_SIZE_GB"
                    reflines="true"
                    linear="false"
                    :refpoint=this.gen_db_size
                    units="GB"
                    color="#3e95cd"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total size of the database data files and temp files in GB.'"
                  title="Database Size (GB)"
                  ></scatterchartcontainer>
                
                 
                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="CPU Threads"
                    chart_id="blended_cpu1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_cpu1
                    units="threads"
                    color="orange"
                    scale="100"
                    v-b-popover.hover.top="'This shows the 99th Percentile value of the Average # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU Usage Per Sec).  For a RAC cluster, this chart aggregates the usage across all instances.'"
                  title="CPU Threads"
                  ></scatterchartcontainer>
                
                  
                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="IOPS"
                    chart_id="blended_iops1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_iops1
                    units="IOPS"
                    color="green"
                    scale="1"
                    v-b-popover.hover.top="'This shows the Average of the Peak IOPS rate (Database IO Requests/second) during each snapshot time period using the Oracle metrics: (Physical Read Total IO Requests Per Sec, Physical Write Total IO Requests Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.'"
                  title="IOPS"
                  ></scatterchartcontainer>

                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="IO Throughput (MB/s)"
                    chart_id="blended_iomb1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_iomb1
                    units="MB/s"
                    color="red"
                    scale="1"
                    v-b-popover.hover.top="'This shows the Average of the Peak IO throughput rates (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.'"
                  title="IO Throughput (MB/s)"
                  ></scatterchartcontainer>
                  
                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="Database Tables"
                    chart_id="COUNT_TABLE"
                    reflines="true"
                    linear="false"
                    :refpoint=this.count_table
                    units="Tables"
                    color="purple"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total number of database tables.'"
                  title="Database Tables"
                  ></scatterchartcontainer>

                  <scatterchartcontainer
                    v-if="showCollapseSummary && loaded"
                    :collection_type="collection_type"
                    :user="user"
                    label="Lines of PLSQL"
                    chart_id="COUNT_LINES_PLSQL"
                    reflines="true"
                    linear="false"
                    :refpoint=this.count_lines_plsql
                    units="Lines"
                    color="purple"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total number of lines of PLSQL.'"
                  title="Lines of PLSQL"
                  ></scatterchartcontainer>
 
                </div>

            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Wait metrics -->
        <b-card
          v-if="loaded"
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionSessions variant="info">Wait Metrics</b-btn>
          </b-card-header>
          <b-collapse id="accordionSessions" v-model="showCollapseSessions" role="tabpanel">
            <b-card-body>
              This shows the top 10 wait events across all snapshots.  Each bar represents the wait time (in seconds) spent {{ this.collection_id>20830 ? 'per second ' : ''}}for that wait event during the individual snapshot time period.  Bars are displayed stacked.  Click on the legend to remove a wait event from the chart.
              <div class="Chart__list">
                <div
                  class="Chart"
                  
                >
                  <h2>Top Waits - Wait time(seconds) per {{ this.collection_id>20830 ? 'second' : 'snapshot interval'}}</h2>
                  <timebarchartncontainer
                    v-if="showCollapseSessions && loaded"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="notused"
                    chart_id="TOP_WAITS2"
                    stacked="true"
                  ></timebarchartncontainer>
                </div>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>
    
        <!-- Exadata observations -->
        <b-card
          v-if="loaded && showExadata"
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionExadata variant="info">Exadata</b-btn>
          </b-card-header>
          <b-collapse id="accordionExadata" v-model="showCollapseExadata" role="tabpanel">
            <b-card-body>
              
              <div class="Chart__list">
                <div class="Chart">
                  <h2>Exadata Observations</h2>
                  <exadataobservations
                    v-if="showCollapseExadata && loaded"
                    :param_collection_id="`${this.param_collection_id}`"
                    :param_item="`${JSON.stringify(this.batchItems[0])}`"
                    collection_type="ora_v1"
                    :user="user"
                  ></exadataobservations>
                </div>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>
     
  </div>
 </div>  
</template>

<script>
import { API } from "aws-amplify";
import ScatterChartContainer from "./ScatterChartContainer.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import ExadataObservations from "./ExadataObservations.vue";

export default {
  name: "GeneralInfoModal",
  components: {
    timebarchartncontainer: TimeBarChartNContainer,
    exadataobservations: ExadataObservations,
    scatterchartcontainer: ScatterChartContainer
  },
  props: ["param_collection_id", "user", "collection_type","param_item"],
  data: () => ({
    loaded: false,
    shareMode: false,
    collection_id: "",
    genItems: [{ name: "Retrieving Data..." }],
    showExadata: false,
    showCollapseSummary: true,     
    showCollapseSessions: true,
    showCollapseExadata: true,
      blended_cpu1: "",
      blended_iops1: "",
      blended_iomb1: "",
      gen_db_size: "",
      count_table: "",
      count_lines_plsql: "",
            batchItems: [ {VERSION: "19", PLATFORM_NAME: "Linux_x86_64-bit", IS_PDB: "NO", "Exadata": "No", IOPS:"0", SmartScanEligible:0, StorageIndexSavings:0, Throughput:1000, SE2_Comments: "" } ]

  }),
  async mounted() {
    this.loaded = false;
    
    this.collection_id = this.param_collection_id;
    // is this shareMode?
    if ( (this.param_collection_id.substring(0,2)=="SD")  || (this.param_collection_id.substring(0,2)=="SB")) {
      // console.log("shareMode");
      this.collection_id=this.param_collection_id.substring(2).split('-')[1];
      this.shareMode=true;
    }
    
    



    
    var tries = 2;
    var batchsuccess=false;
    var isOK = true;
  //   while (tries > 0) {
  //     await API.get(
  //       "dbcsiAPI",
  //       `/dbcsi/authorized/${this.param_collection_id}`
  //     )
  //       .then(response => {
  //         if (response.data.authorized!="Y") {
  //           // console.log("Sorry, not authorized to view this collection.  Routing back to main page.");      
  //           // this.$router.push('/');
  //           tries = 0;
  //           isOK=false;
            
  //         }
  //       })
  //       .catch(error => {
  //         console.log("GIM-authorized Error:", error);
  //         console.log("Will retry.  Attempts Left:", (tries-1));
  //       });
  //     tries -= 1;
		// }
		
		if (!isOK) return;

    // console.log("I am here1");
    tries = 2;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/${this.param_collection_id}/${this.collection_type}`
      )
        .then(response => {
          
          this.genItems = response.data;
          
          //if no rows, then not authorized
          if (this.genItems.length==0) {
            // console.log("GIM- Sorry, not authorized to view this collection.  Routing back to main page.");      
            // this.$router.push('/');
          } 
          
          //pull out platform and DBsize
          
          for (var ii = 0; ii < this.genItems.length; ii++) {



            //TOTAL_DB_SIZE_GB
            if (this.genItems[ii].name == "TOTAL_DB_SIZE_GB") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_db_size = this.genItems[ii].value;
            }
            //COUNT_TABLE
            if (this.genItems[ii].name == "COUNT_TABLE") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_table = this.genItems[ii].value;
            }
            //COUNT_LINES_PLSQL
            if (this.genItems[ii].name == "COUNT_LINES_PLSQL") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_lines_plsql = this.genItems[ii].value;
            }
             
            //hide socket values
            if ((this.genItems[ii].name == "!CPU_SOCKET_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_SOCKET_COUNT") ||(this.genItems[ii].name == "NUM_CPU_SOCKETS")  ) {
              // console.log("Removing socket1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing socket2", this.genItems.length);
              ii--;
            }
            
            //hide DEBUG values
            if ( this.genItems[ii].name.startsWith("DEBUG")  ) {
              // console.log("Removing DEBUG1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing DEBUG2", this.genItems.length);
              ii--;
            }
            
            //hide DB_ values
             if ( this.genItems[ii].name.startsWith("DB_") && this.genItems[ii].name!="DB_NAME" ) {
              this.genItems.splice(ii,1);
              ii--;
            }
           

            
            
          }
         


          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("GIM-GeneralItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }

// console.log("GIM", this.param_item);      
    //did we get additional_datapoints as input?  If not, query new data
    if (this.param_item != undefined) {
      this.batchItems[0] = JSON.parse(this.param_item);
    }  
    if ( (this.param_item == undefined) || (this.batchItems[0].additional_datapoints == undefined) ) {
      
      // console.log("GIM, fetching new data");
      tries = 2;
      
      while (tries > 0) {
        await API.get(
          "dbcsiAPI",
          `/dbcsi/batch/${this.shareMode ? this.param_collection_id : ('C' + this.collection_id) }`
        )
          .then(response => {
  				// 	console.log("get batch success ",response);
  					if (response.success) {
  					   if (response.data.length>0) {
                  this.batchItems = response.data;
                 batchsuccess=true;
  					   } else {
  					     console.log("metrics- no data returned from /batch/Cxxxx");
  					     batchsuccess=false;
  					   }  
            
   
            
  					tries = 0;
  					// console.log("get batch set batchItems:"+this.batchItems.length);
  					}
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("Metrics-batchItems Error:", error);
            console.log("Will retry.  Attempts Left:", (tries-1));
          });
        tries -= 1;
  		}
  
  
  
      
  
      
      // now get additional data
      
      if (batchsuccess) {
          //clear out existing configs
                   
          for (var agroupi=0; agroupi< this.batchItems.length ; agroupi++) {
            this.batchItems[agroupi].targetconfig_rds = null;
            this.batchItems[agroupi].targetconfig_aurora = null;
  
          }  
  
  
  
            this.flatItems = [];
  
  
  
  
            var  batchParams = {
                body: {
                  outliers: {
                    IOPS: 50000,
                    IOMB: 8000,
                    VCPU: 50
                  }
                }
              };
  
              //is this a PDB?
              var pdb_response = {};
              if (this.batchItems[0].IS_PDB=="YES") {
                  tries = 4;
                  while (tries > 0) {
                    tries -= 1;  
                  
                    await API.put(
                      "dbcsiAPI",
                      `/dbcsi/batch/additional_pdb_percentiles/${this.batchItems[0].collectionID}`,  
                      batchParams
                    )
                      .then(response => {
                        // console.log("additional_pdb_percentiles", response.data);
                        pdb_response = response.data;
                        //if we have CDB_IOPS, use those as new outliers
                        if (pdb_response.CDB_IOPS != undefined) {
                          console.log("setting new outliers based on CDB");
                          batchParams.body.outliers.IOPS = pdb_response.CDB_IOPS;
                          batchParams.body.outliers.IOMB = pdb_response.CDB_IOMB;
                          batchParams.body.outliers.VCPU = pdb_response.CDB_VCPU;
                        }
                        tries=0;
  
                      } 
                      )
                      .catch(error => {
                        console.log("GIM- additional_pdb_percentiles.put Error. Tries:", tries);
                          // this.alertTextRecalc = "Error while additional_datapoints: "+error;
                          // this.alertStyleRecalc="danger";
  
                      });
                  }    
                
              }
  
              var response = {
                data: ""
              };
  
              tries = 4;
              while (tries > 0) {
                tries -= 1;  
              
                await API.put(
                  "dbcsiAPI",
                  `/dbcsi/batch/additional_percentiles/${this.batchItems[0].collectionID}`,  
                  batchParams
                )
                  .then(newresponse => {
                    // console.log("additional_percentiles", newresponse.data);
                    var main_response=newresponse.data;
                    //merge in PDB values
                    if (this.batchItems[0].IS_PDB=="YES") {
                      main_response.DB_PDB2_IOMB_AVERAGE_P99 = pdb_response.DB_PDB2_IOMB_AVERAGE_P99;
                      main_response.DB_PDB2_CPU_THREADS_AVERAGE_P99 = pdb_response.DB_PDB2_CPU_THREADS_AVERAGE_P99;
                      main_response.CDB_IOPS = pdb_response.CDB_IOPS;
                      main_response.CDB_IOMB = pdb_response.CDB_IOMB;
                      main_response.CDB_VCPU = pdb_response.CDB_VCPU;
                      main_response.CDB_DBID = pdb_response.CDB_DBID;
                      main_response.CDB_collectionId = pdb_response.CDB_collectionId;
                      main_response.cdb_target_comments = pdb_response.cdb_target_comments;
                    }
                    batchParams.body.inputs = main_response;
                    this.batchItems[0].additional_datapoints = main_response;
                    this.batchItems[0].assumptionsArray=[];
                    this.batchItems[0].SmartScanEligible=main_response.DB_EXA_CELL_BYTES_ELIG_MB_P99;
                    this.batchItems[0].StorageIndexSavings=main_response.DB_EXA_CELL_SI_SAVE_MB_P99;
  
                    response.data = main_response;
                    tries=0;
  
                  } 
                  )
                  .catch(error => {
                    console.log("GIM- additional_percentiles.put Error. Tries:", tries);
                      // this.alertTextRecalc = "Error while additional_datapoints: "+error;
                      // this.alertStyleRecalc="danger";
  
                  });
              }    

          this.blended_cpu1=response.data.blended_cpu1;
          this.blended_iops1=response.data.blended_iops1;
          this.blended_iomb1=response.data.blended_iomb1;


      }

                


    } else {
      // console.log("GIM, reusing param_item");
      // this.batchItems[0] = JSON.parse(this.param_item);
      this.blended_cpu1=this.batchItems[0].additional_datapoints.blended_cpu1;
      this.blended_iops1=this.batchItems[0].additional_datapoints.blended_iops1;
      this.blended_iomb1=this.batchItems[0].additional_datapoints.blended_iomb1;
    }  


   if ( (this.batchItems[0].Exadata != undefined) && (this.batchItems[0].Exadata == "Yes") ) {
     this.showExadata= true;
   }
    this.loaded = true;

  }
};
</script>